import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, Responsive } from '@cian/ui-kit';
import { trackShowListingProjects } from '../../containers/Projects/tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export const Title = () => {
  return (
    <ActionAfterViewObserver callback={trackShowListingProjects} triggerOnce>
      <>
        <Responsive desktop>
          <ArticleHeading1 as="h2">Объекты от застройщика</ArticleHeading1>
        </Responsive>
        <Responsive phone tablet>
          <ArticleHeading2 as="h2">Объекты от застройщика</ArticleHeading2>
        </Responsive>
      </>
    </ActionAfterViewObserver>
  );
};
